import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
// @ts-expect-error file not migrated yet
import propertyValueToNumber from 'customer-data-sidebar/universal/dataAccessHelpers/propertyValueToNumber';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { getPropertyValueFromProperties } from '../../../helpers/propertiesHelpers';
import AutosaveChickletStageSelect from '../../../chicklets/AutosaveChickletStageSelect';
import emptyFunction from 'react-utils/emptyFunction';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { getUserCanEditAssociation } from '../../../helpers/migrationHelpers';
import { SecondaryPropertyLabel } from '../../../card/secondaryProperties/SecondaryPropertyDisplay';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const emptyFunctionThatReturnsUndefined = emptyFunction.thatReturns(undefined);
const useGetTicketChickletSecondaryDisplayLabels = ({
  properties,
  object,
  toObjectTypeId,
  readOnly,
  objectId
}) => {
  const fieldLevelAccess = useAccessLevel({
    objectType: toObjectTypeId,
    propertyName: 'hs_pipeline_stage'
  });
  const currentStageId = getPropertyValueFromProperties(properties, 'hs_pipeline_stage');
  const getSavedValue = propertyName => {
    return getPropertyValueFromProperties(properties, propertyName);
  };
  const canEdit = getUserCanEditAssociation(object);
  const renderTicketOwner = propertyDefinition => {
    const ownerId = getPropertyValueFromProperties(properties, 'hubspot_owner_id');
    return /*#__PURE__*/_jsxs(TFlex, {
      align: "center",
      "data-selenium-test": "ticket-chicklet-owner-select",
      "data-test-id": "ticket-chicklet-owner-select",
      children: [/*#__PURE__*/_jsx(SecondaryPropertyLabel, {
        propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardAssociatedObjects.chicklet.TicketChickletSecondaryPropertyLabels.owner"
        })
      }), /*#__PURE__*/_jsx(FormattedPropertyV2, {
        objectTypeId: toObjectTypeId,
        objectId: `${objectId}`,
        value: ownerId,
        getDraftValue: emptyFunctionThatReturnsUndefined,
        getSavedValue: getSavedValue
        // @ts-expect-error Known property issue as they have not updated the type definitions
        // https://hubspot.slack.com/archives/C025K57CMMG/p1696524684019289?thread_ts=1696349045.450059&cid=C025K57CMMG
        ,
        property: propertyDefinition
      })]
    });
  };
  const renderStageSelect = propertyDefinition => {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      "data-selenium-test": "ticket-chicklet-stage-select",
      "data-test-id": "ticket-chicklet-stage-select",
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: 0,
        children: /*#__PURE__*/_jsx(SecondaryPropertyLabel, {
          propertyLabel: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "cardAssociatedObjects.chicklet.TicketChickletSecondaryPropertyLabels.status"
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        minInlineSize: "0",
        children: /*#__PURE__*/_jsx(AutosaveChickletStageSelect, {
          value: currentStageId,
          objectTypeId: toObjectTypeId,
          objectId: objectId,
          stagePropertyDefinition: propertyDefinition,
          readOnly: !canEdit || readOnly,
          fieldLevelAccess: fieldLevelAccess,
          getSavedValue: getSavedValue,
          getDraftValue: emptyFunctionThatReturnsUndefined
        })
      })]
    });
  };
  const closedDate = propertyValueToNumber(getPropertyValueFromProperties(properties, 'closed_date'));
  const createDate = getPropertyValueFromProperties(properties, 'createdate');
  const renderCloseOrCreateDate = () => {
    if (closedDate) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.chicklet.TicketChicklet.closeDate",
        "data-unit-test": "ticket-chicklet-closed-date",
        "data-selenium-test": "ticket-chicklet-closed-date",
        "data-test-id": "ticket-chicklet-closed-date",
        options: {
          date: I18n.moment.userTz(closedDate).format('L')
        }
      });
    }
    return createDate ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.chicklet.TicketChicklet.timeOpen",
      "data-selenium-test": "ticket-chicklet-open-duration",
      "data-test-id": "ticket-chicklet-open-duration",
      options: {
        duration: I18n.moment.userTz(parseInt(createDate, 10)).fromNow(true)
      }
    }) : undefined;
  };
  const propertyFormatters = {
    hs_pipeline_stage: renderStageSelect,
    hubspot_owner_id: renderTicketOwner
  };
  return {
    propertyFormatters,
    copyDisabled: true,
    additionalPrefixContent: renderCloseOrCreateDate()
  };
};
export default useGetTicketChickletSecondaryDisplayLabels;